import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {HttpCallerService} from '@overflo1/frame-frontend';
import {environment} from 'src/environments/environment';
import {SendCommandPayload} from '../../models/send-command.type';
import {MachineModel} from "../../models/machine.model";
import {MachineProfileOptionModel} from "../../models/machine-profile-option.model";

@Injectable({
  providedIn: 'root'
})
export class MachineService extends HttpCallerService {

  constructor(
    protected override readonly http: HttpClient,
  ) {
    super(http, environment.backendBasePath);
  }

  async getMachineFamilyCounters() {
    return await this.get<{count: number, family_name: string}[]>(`/machine/family-counters`);
  }

  async getMachineFamilies(filter?: string) {
    let query = '';
    if (filter) {
      query += `filter=${filter}`;
    }
    return await this.get<string[]>(`/machine/families?${query ?? ''}`);
  }

  async getMachineGroups(filter?: string) {
    let query = '';
    if (filter) {
      query += `filter=${filter}`;
    }
    return await this.get<string[]>(`/machine/groups?${query ?? ''}`);
  }

  async sendCommand(payload: SendCommandPayload) {
    return await this.post<any>(`/machine/send-command`, payload);
  }

  async getCommandsHistory(machineId: number, limit = 10, offset = 0, sortField = 'sentAt', sortDir = 'desc') {
    return await this.get<{ data: any[], total: number }>(
      `/machine/${machineId}/commands-history?limit=${limit}&offset=${offset}&sortField=${sortField}&sortDir=${sortDir}`
    );
  }

  async cancelPendingCommand(machineId: number) {
    return await this.post<void>(`/machine/${machineId}/cancel-command`, {});
  }

  async getSlimMachines(): Promise<Partial<MachineModel>[]> {
    return this.get<Partial<MachineModel>[]>('/machine/slim');
  }

  async getAssociations(machineId: number): Promise<Partial<MachineModel>[]> {
    return this.get<Partial<MachineModel>[]>(`/machine/${machineId}/associations`);
  }

  async updateAssociations(
    machineId: number,
    machineIds: number[],
  ): Promise<void> {
    return this.patch<void>(`/machine/${machineId}/associations`, { machineIds });
  }

  async restoreMachine(machineId: number): Promise<void> {
    return this.patch<void>(`/machine/${machineId}/restore`, {});
  }

  async getAllProfiles() {
    return this.get<MachineProfileOptionModel[]>('/machine/profiles-list');
  }
}
